import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import SEOHead from "@/components/layout/SEOHead";
import { PageHero } from "@/pages/About.hero";
import { ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function News() {
  const [posts, setPosts] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios.get(`${API}/news`).then(r => setPosts(r.data)).catch(() => {}).finally(() => setLoaded(true));
  }, []);

  return (
    <>
      <SEOHead
        title="News & Updates from Temple Israel of Brevard"
        description="Latest news, rabbinical messages, community updates, and lifecycle announcements from Temple Israel of Brevard."
        path="/news"
      />
      <PageHero
        eyebrow="Community News"
        title="News from TIOB"
        subtitle="Rabbinical messages, community milestones, and updates worth sharing."
      />
      <section className="bg-white py-14 lg:py-20">
        <div className="max-w-4xl mx-auto px-5 lg:px-10">
          {!loaded ? <p className="text-center text-[color:var(--muted)]">Loading…</p>
            : posts.length === 0 ? (
              <p className="text-center text-[color:var(--muted)]">
                No posts yet. Check back soon.
              </p>
            ) : (
              <div className="space-y-10" data-testid="news-list">
                {posts.map(p => (
                  <article key={p.id} className="grid md:grid-cols-[220px_1fr] gap-6" data-testid={`news-item-${p.slug}`}>
                    {p.image_url && (
                      <Link to={`/news/${p.slug}`} className="block rounded-xl overflow-hidden border border-[var(--line)]">
                        <img src={p.image_url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${p.image_url}` : p.image_url}
                             alt="" className="w-full h-40 md:h-full object-cover" loading="lazy" />
                      </Link>
                    )}
                    <div>
                      <p className="text-xs text-[var(--muted)] uppercase tracking-widest font-mono-accent">{p.date}</p>
                      <h2 className="font-display text-2xl md:text-3xl text-[var(--blue-ink)] mt-1">
                        <Link to={`/news/${p.slug}`} className="hover:text-[var(--blue-deep)]">{p.title}</Link>
                      </h2>
                      {p.excerpt && <p className="mt-2 text-[var(--ink-soft)]">{p.excerpt}</p>}
                      <Link to={`/news/${p.slug}`} className="mt-3 inline-flex items-center gap-1 text-[var(--blue-deep)] font-medium hover:text-[var(--blue)]">
                        Read more <ArrowUpRight size={14} />
                      </Link>
                    </div>
                  </article>
                ))}
              </div>
            )}
        </div>
      </section>
    </>
  );
}
